import { chainManager } from '../ChainManager';

export async function getTokenDecimalsViaChainManager(tokenAddress: string): Promise<number> {
  const adapter = chainManager.getCurrentAdapter();
  if (!adapter?.getTokenDecimals) throw new Error('Adapter chưa hỗ trợ getTokenDecimals');
  return adapter.getTokenDecimals(tokenAddress);
}
